<style scoped>
.calendar {
  margin: auto;
  width: 100%;
  min-width: 300px;
  /*background: #fff;*/
  /*font-family: "PingFang SC", "Hiragino Sans GB", "STHeiti", "Microsoft YaHei",
    "WenQuanYi Micro Hei", sans-serif;*/
  -moz-user-select: none;
  /*火狐*/
  -webkit-user-select: none;
  /*webkit浏览器*/
  -ms-user-select: none;
  /*IE10*/
  -khtml-user-select: none;
  /*早期浏览器*/
  user-select: none;
  margin-bottom: 0.7rem;
  /*border-bottom: 1px solid #f1f1f1;*/
  /*height: 3.8rem;*/
}

.calendar-tools {
  height: 40px;
  font-size: 20px;
  line-height: 40px;
  color: #5e7a88;
  position: absolute;
  top: 0.35rem;
}

/*.calendar-tools span {*/
/*  cursor: pointer;*/
/*}*/
.calendar-prev {
  width: 14.28571429%;
  /*float: left;*/
  text-align: center;
  position: absolute;
  left: 6.2rem;
}

.calendar-info {
  padding-top: 3px;
  font-size: 0.52rem;
  /*line-height: 1.3;*/
  text-align: center;
  position: absolute;
  left: 3.5rem;
  top: 0.1rem;
}

.yearText {
  text-align: center;
  font-size: 26px;
  color: #fff;
  z-index: 333;
}

.jiantou {
  width: 0.68rem;
  height: 0.68rem;
  background: url('../../assets/ticket/ca_jiantou.png') 0 0/contain no-repeat;
  position: absolute;
  left: 0rem;
  top: 0rem;
  margin: 0.5rem;
  z-index: 222;
}

.jiantouLeft {
  transform: rotate(180deg);
}

.jiantouRight {
  left: 7.7rem;
}

.jiantouGray {
  background: url('../../assets/ticket/ca_jiantou_gray.png') 0 0/contain no-repeat;
}

.calendar-info>div.month {
  margin: auto;
  height: 0.50rem;
  line-height: 0.5rem;
  width: 4rem;
  text-align: center;
  overflow: hidden;
  position: relative;
  color: #333333;
  z-index: 111;
  margin-top: 0.4rem;
  font-weight: 500;
}

.calendar-info>div.month .month-inner {
  position: absolute;
  left: 0;
  top: 0;
  height: 240px;
}

.calendar-info>div.month .month-inner>span {
  display: block;
  font-size: 0.52rem;
  height: 0.6rem;
  width: 4rem;
  overflow: hidden;
  text-align: left;
}

.pcCalendar .calendar-info>div.month .month-inner>span {
  font-size: 28px;
  width: auto;
}

.calendar-info>div.year {
  font-size: 10px;
  line-height: 1;
  color: #999;
}

.calendar-next {
  width: 14.28571429%;
  /*float: right;*/
  text-align: center;
  position: absolute;
  left: 7.75rem;
}

.calendar table {
  clear: both;
  width: 100%;
  padding-bottom: 10px;
  border-collapse: collapse;
  color: #3F6F51;
}

.calendar table .week {
  color: #666;
  font-size: 0.373rem;
}

.calendar td {
  margin: 0.05rem !important;
  padding: 0px 0;
  width: 14.28571429%;
  height: 1.2rem;
  text-align: center;
  vertical-align: middle;
  font-size: 14px;
  line-height: 120%;
  /*cursor: pointer;*/
  position: relative;
  vertical-align: top;
  pointer-events: auto !important;
}

.calendar td.week {
  font-size: 0.5rem;
  pointer-events: none !important;
  cursor: default !important;
}

.calendar td.disabled {
  color: #999999;
  pointer-events: none !important;
  cursor: default !important;
}

.calendar td.disabled:after {
  display: none;
}

/*.calendar td.disabled div {
  color: #8e8888;
}*/
.calendar td.close {
  color: #391F1F;
}

.pcCalendar td.disabled div {
  font-size: 14px;
  height: 20px;
  line-height: 20px;
  margin-top: 0;
  margin-left: -2px;
  top: 40px;
}

.pcCalendar .calendar-info {
  left: 400px;
  top: -60px;
}

.calendar td span {
  display: block;
  /*max-width: 40px;*/
  height: 0.67rem;
  font-size: 0.427rem;
  line-height: 0.67rem;
  margin: 0.3rem auto 0 auto;
  border-radius: 20px;
}

/*.calendar td.selected {
  background-image: linear-gradient(90deg, #a42f15 0%, #eb8751 100%),
    linear-gradient(#3475ba, #3475ba);
  color: #fff;
  border-radius: 0.487rem;
}*/
.calendar td.selected .text {
  /*color: #fff;*/
  /*margin-top: 0.7rem;*/
}

.calendar td .text {
  position: absolute;
  top: 8px;
  left: 0;
  right: 0;
  text-align: center;
  margin: 0.65rem auto 0 auto;
  padding: 0.05rem;
  font-size: 0.3rem;
  /*line-height: 1.2;*/
  /*color: #3F6F51;*/
  width: 0.98rem;
  height: 1rem;
  line-height: 0.5rem;
  /*display: inline-block !important;*/
}

.pcCalendar td .text {
  font-size: 14px;
  margin-top: 0;
  top: 40px;
  height: 20px;
  margin-left: -2px;
  line-height: 20px;
}

.calendar td .isGregorianFestival,
.calendar td .isLunarFestival {
  color: #ea6151;
}

.calendar thead td {
  text-transform: uppercase;
  height: 1.2rem;
  line-height: 1.2rem;
  vertical-align: middle;
}

.calendar-button {
  text-align: center;
}

.calendar-button span {
  cursor: pointer;
  display: inline-block;
  min-height: 1em;
  min-width: 5em;
  vertical-align: baseline;
  background: #5e7a88;
  color: #fff;
  margin: 0 0.25em 0 0;
  padding: 0.6em 2em;
  font-size: 1em;
  line-height: 1em;
  text-align: center;
  border-radius: 0.3em;
}

.calendar-button span.cancel {
  background: #efefef;
  color: #666;
}

.calendar-years {
  position: absolute;
  left: 0px;
  top: 60px;
  right: 0px;
  bottom: 0px;
  background: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  overflow: auto;
  transition: all 0.5s cubic-bezier(0.075, 0.82, 0.165, 1);
  opacity: 0;
  pointer-events: none;
  transform: translateY(-10px);
}

.calendar-years.show {
  opacity: 1;
  pointer-events: auto;
  transform: translateY(0px);
}

.calendar-years>span {
  margin: 1px 5px;
  display: inline-block;
  width: 60px;
  line-height: 30px;
  border-radius: 20px;
  text-align: center;
  border: 1px solid #fbfbfb;
  color: #999;
}

.calendar-years>span.active {
  border: 1px solid #5e7a88;
  background-color: #5e7a88;
  color: #fff;
}

th,
td,
tr,
thead,
tbody {
  display: inline-block;
}

thead {
  width: 100%;
}

tbody {
  /*height: 150px;*/
  overflow-y: auto;
  overflow-x: hidden;
  /*padding-bottom: 0.5rem;*/
}

th,
td {
  width: 1.1rem !important;
}

tr {
  width: 100% !important;
  text-align: left;
  padding-bottom: 0.26rem;
}
</style>

<template>
  <div class="calendar">
    <div class="calendar-tools">
      <div :class="`jiantou jiantouLeft ${month > nowMonth ? '' : 'jiantouGray'}`"
        @click="month > nowMonth ? prev() : ''"></div>
      <div class="calendar-info">
        <div class="month">
          <div class="month-inner">
            <span>{{ year }}年{{ month + 1 }}月</span>
          </div>
        </div>
      </div>
      <div :class="`jiantou jiantouRight ${month <= nowMonth ? '' : 'jiantouGray'}`"
        @click="month <= nowMonth ? next() : ''"></div>
    </div>
    <table cellpadding="5">
      <thead>
        <tr>
          <td v-for="week in weeks" class="week" :key="week">{{ week }}</td>
        </tr>
      </thead>
      <tbody>
        <swiper :options="swiperOption" ref="mySwiper" data-type="0">
          <template v-for="(day, k1) in days">
            <swiper-slide v-if="k1 == 0" :key="k1" :id="k1">
              <!-- {{k1}} -->
              <!-- v-show="k1%2 == 0" -->
              <tr style="{'animation-delay',(k1*30)+'ms'}" ref="days">
                <template v-for="(day, di) in days">
                  <td v-for="(child, k2) in days[di]" :key="`${child.day}_${child.lunar}_${di}`" :class="{
        selected: child.selected && child.eventName == '有票',
        disabled: child.disabled || child.eventName != '有票',
        today: child.isToday,
        close: child.eventName == '闭馆'
      }" @click="select(di, k2, $event)" v-show="child.month != month + 2 || isMobile">
                    <span :class="{
        red:
          k2 == 0 ||
          k2 == 6 ||
          ((child.isLunarFestival || child.isGregorianFestival) &&
            lunar)
      }" v-show="child.month == month + 1 || isMobile">{{ child.month != month + 1 && isMobile ? '' :
        child.day }}</span>
                    <div :class="`text ${child.eventName == '无票' ? 'text_red' : ''}`" v-html="child.eventName"
                      v-show="child.eventName && child.month == month + 1"></div>
                    <div class="text" :class="{
        isLunarFestival: child.isLunarFestival,
        isGregorianFestival: child.isGregorianFestival
      }" v-if="lunar">
                      {{ child.lunar }}
                    </div>
                  </td>
                </template>
              </tr>
            </swiper-slide>
          </template>
        </swiper>
      </tbody>
    </table>
    <div class="calendar-years" :class="{ show: yearsShow }">
      <span v-for="y in years" :key="y" @click.stop="selectYear(y)" :class="{ active: y == year }">{{ y }}</span>
    </div>
  </div>
</template>

<script>
import calendar from "./calendar.js";
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";

export default {
  components: {
    swiper,
    swiperSlide
  },
  props: {
    // 多选模式
    multi: {
      type: Boolean,
      default: false
    },
    // 范围模式
    range: {
      type: Boolean,
      default: false
    },
    // 默认日期
    value: {
      type: Array,
      default: function () {
        return [];
      }
    },
    // 开始选择日期
    begin: {
      type: Array,
      default: function () {
        return [];
      }
    },
    // 结束选择日期
    end: {
      type: Array,
      default: function () {
        return [];
      }
    },

    // 是否小于10补零
    zero: {
      type: Boolean,
      default: false
    },
    // 屏蔽的日期
    disabled: {
      type: Array,
      default: function () {
        return [];
      }
    },
    // 是否显示农历
    lunar: {
      type: Boolean,
      default: false
    },

    // 自定义星期名称
    weeks: {
      type: Array,
      default: function () {
        return window.navigator.language.toLowerCase() == "zh-cn"
          ? ["日", "一", "二", "三", "四", "五", "六"]
          : ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
      }
    },
    // 自定义月份
    months: {
      type: Array,
      default: function () {
        return window.navigator.language.toLowerCase() == "zh-cn"
          ? [
            "一月",
            "二月",
            "三月",
            "四月",
            "五月",
            "六月",
            "七月",
            "八月",
            "九月",
            "十月",
            "十一月",
            "十二月"
          ]
          : [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December"
          ];
      }
    },
    // 自定义事件
    events: {
      type: Object,
      default: function () {
        return {};
      }
    },
    isMobile: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      years: [],
      yearsShow: false,
      year: 0,
      month: 0,
      day: 0,
      nowMonth: 0,
      days: [],
      multiDays: [],
      today: [],
      festival: {
        lunar: {
          "1-1": "春节",
          "1-15": "元宵节",
          "2-2": "龙头节",
          "5-5": "端午节",
          "7-7": "七夕节",
          "7-15": "中元节",
          "8-15": "中秋节",
          "9-9": "重阳节",
          "10-1": "寒衣节",
          "10-15": "下元节",
          "12-8": "腊八节",
          "12-23": "祭灶节"
        },
        gregorian: {
          "1-1": "元旦",
          "2-14": "情人节",
          "3-8": "妇女节",
          "3-12": "植树节",
          "4-5": "清明节",
          "5-1": "劳动节",
          "5-4": "青年节",
          "6-1": "儿童节",
          "7-1": "建党节",
          "8-1": "建军节",
          "9-10": "教师节",
          "10-1": "国庆节",
          "12-24": "平安夜",
          "12-25": "圣诞节"
        }
      },
      rangeBegin: [],
      rangeEnd: [],
      swiperOption: {
        // some swiper options/callbacks
        // 所有的参数同 swiper 官方 api 参数
        // autoplay: true,
        observer: true,
        observeParents: true,
        allowTouchMove: true,
        // passiveListeners: false,
        preventClicksPropagation: false,
        watchSlidesProgress: true,
        loop: true,
        // threshold : 1001,
        on: {
          touchMove: event => {
            //  上下周均为无效日期时禁止滑动
            // event.stopPropagation();
            let swiper = this.$refs.mySwiper.swiper;
            let x = swiper.touches.currentX - swiper.touches.startX;
            // console.log(x);
            // console.log(swiper.touches.diff);
            let satClass = document
              .querySelectorAll(".swiper-slide-active")[0]
              .children[0].getElementsByTagName("td")[6]._prevClass;
            let sunClass = document
              .querySelectorAll(".swiper-slide-active")[0]
              .children[0].getElementsByTagName("td")[0]._prevClass;
            let nextSatClass = document
              .querySelectorAll(".swiper-slide-next")[0]
              .children[0].getElementsByTagName("td")[6]._prevClass;
            let nextSunClass = document
              .querySelectorAll(".swiper-slide-next")[0]
              .children[0].getElementsByTagName("td")[0]._prevClass;
            let prevSatClass = document
              .querySelectorAll(".swiper-slide-prev")[0]
              .children[0].getElementsByTagName("td")[6]._prevClass;
            let prevSunClass = document
              .querySelectorAll(".swiper-slide-prev")[0]
              .children[0].getElementsByTagName("td")[0]._prevClass;
            // console.log(prevSatClass);
            // console.log(prevSunClass);
            // if (sunClass === "disabled" && x > 0) {
            //   console.log("无法返回上周");
            //   swiper.allowSlidePrev = false;
            // } else if (
            //   prevSatClass === "disabled" &&
            //   x > 0 &&
            //   !swiper.isBeginning
            // ) {
            //   console.log("也无法返回上周");
            //   swiper.allowSlidePrev = false;
            // } else if (satClass === "disabled" && x < 0) {
            //   console.log("无法到下周");
            //   // swiper.allowSlideNext = false;
            // } else if (nextSunClass === "disabled" && x < 0 && !swiper.isEnd) {
            //   swiper.allowSlideNext = false;
            //   console.log("也无法到下周");
            // } else {
            //   console.log("正常切换");
            //   swiper.allowSlideNext = true;
            //   swiper.allowSlidePrev = true;
            // }
            swiper.allowSlideNext = true;
            swiper.allowSlidePrev = true;
          },
          touchEnd: event => {
            // event.stopPropagation();
            // let swiper = this.$refs.mySwiper.swiper;
            // let x = swiper.touches.currentX - swiper.touches.startX;
            // //解决切换月份与点击冲突问题
            // if (swiper.isEnd && x === 0) {
            //   // console.log(swiper.isEnd);
            // } else if (swiper.isEnd && x < 0) {
            //   // console.log(swiper.isEnd);
            //   this.next();
            // } else if (swiper.isBeginning && x === 0) {
            //   // console.log(swiper.isBeginning);
            // } else if (swiper.isBeginning && x > 0) {
            //   // console.log(swiper.isBeginning);
            //   this.prev();
            // }
          },
          tap: function (event) {
            // alert('你碰了Swiper');
            // document.body.addEventListener(
            //   "touchmove",
            //   function(event) {
            //     event.preventDefault();
            //   },
            //   false
            // );
          }
        }
      }
    };
  },
  watch: {
    // events(val) {
    //   console.log(this.events);
    //   console.log(val);
    //   console.log(this.year);
    //   console.log(this.month);
    //   this.render(this.year, this.month);
    //   this.$nextTick(() => {
    //     this.shield();
    //   });
    // },
    events: {
      handler(newName, oldName) {
        this.render(this.year, this.month);
        this.$nextTick(() => {
          // this.shield();
        });
      },
      // immediate: true,开启此选项会滑动月份错乱
      deep: true
    },
    value(val) {
      this.init();
    }
  },
  methods: {
    init() {
      let now = new Date();
      this.year = now.getFullYear();
      this.month = now.getMonth();
      this.day = now.getDate();
      if (this.value.length > 0) {
        if (this.range) {
          //范围
          this.year = parseInt(this.value[0][0]);
          this.month = parseInt(this.value[0][1]);
          this.day = parseInt(this.value[0][2]);
          let year2 = parseInt(this.value[1][0]);
          let month2 = parseInt(this.value[1][1]);
          let day2 = parseInt(this.value[1][2]);
          this.rangeBegin = [this.year, this.month, this.day];
          this.rangeEnd = [year2, month2, day2];
        } else if (this.multi) {
          //多选
          this.multiDays = this.value;
          this.year = parseInt(this.value[0][0]);
          this.month = parseInt(this.value[0][1]) - 1;
          this.day = parseInt(this.value[0][2]);
        } else {
          //单选
          this.year = parseInt(this.value[0]);
          this.month = parseInt(this.value[1]) - 1;
          this.day = parseInt(this.value[2]);
        }
      }
      this.day += this.day
      let begin = this.rangeBegin;
      let end = this.rangeEnd;
      // console.log("选中日期",begin,end)
      // this.$emit("select", begin, end);
      this.render(this.year, this.month);
      console.log('123451')
      console.log(begin)
      console.log(end)
      // this.render(this.year, this.day);
    },
    // 渲染日期
    render(y, m, type) {
      let firstDayOfMonth = new Date(y, m, 1).getDay(); //当月第一天
      let lastDateOfMonth = new Date(y, m + 1, 0).getDate(); //当月最后一天
      let lastDayOfLastMonth = new Date(y, m, 0).getDate(); //最后一月的最后一天
      // debugger;
      this.year = y;
      let seletSplit = this.value;
      let i,
        line = 0,
        temp = [],
        nextMonthPushDays = 1;
      for (i = 1; i <= lastDateOfMonth; i++) {
        let day = new Date(y, m, i).getDay(); //返回星期几（0～6）
        let k;
        // 第一行
        if (day == 0) {
          temp[line] = [];
        } else if (i == 1) {
          temp[line] = [];
          k = lastDayOfLastMonth - firstDayOfMonth + 1;
          for (let j = 0; j < firstDayOfMonth; j++) {
            // console.log("第一行",lunarYear,lunarMonth,lunarValue,lunarInfo)
            temp[line].push(
              Object.assign(
                { day: k, disabled: true },
                this.getLunarInfo(
                  this.computedPrevYear(),
                  this.computedPrevMonth(true),
                  k
                ),
                this.getEvents(
                  this.computedPrevYear(),
                  this.computedPrevMonth(true),
                  k
                )
              )
            );
            k++;
          }
        }
        if (this.range) {
          // 范围
          console.log(
            "日期范围",
            this.getLunarInfo(this.year, this.month + 1, i)
          );
          let options = Object.assign(
            { day: i },
            this.getLunarInfo(this.year, this.month + 1, i),
            this.getEvents(this.year, this.month + 1, i)
          );
          if (this.rangeBegin.length > 0) {
            let beginTime = Number(
              new Date(
                this.rangeBegin[0],
                this.rangeBegin[1],
                this.rangeBegin[2]
              )
            );
            let endTime = Number(
              new Date(this.rangeEnd[0], this.rangeEnd[1], this.rangeEnd[2])
            );
            let stepTime = Number(new Date(this.year, this.month, i));
            if (beginTime <= stepTime && endTime >= stepTime) {
              options.selected = true;
            }
          }
          if (this.begin.length > 0) {
            let beginTime = Number(
              new Date(
                parseInt(this.begin[0]),
                parseInt(this.begin[1]) - 1,
                parseInt(this.begin[2])
              )
            );
            if (beginTime > Number(new Date(this.year, this.month, i)))
              options.disabled = true;
          }
          if (this.end.length > 0) {
            let endTime = Number(
              new Date(
                parseInt(this.end[0]),
                parseInt(this.end[1]) - 1,
                parseInt(this.end[2])
              )
            );
            if (endTime < Number(new Date(this.year, this.month, i)))
              options.disabled = true;
          }
          if (this.disabled.length > 0) {
            if (
              this.disabled.filter(v => {
                return (
                  this.year === v[0] && this.month === v[1] - 1 && i === v[2]
                );
              }).length > 0
            ) {
              options.disabled = true;
            }
          }
          if (options.eventName) {
            options.disabled = true;
          }
          temp[line].push(options);
        } else if (this.multi) {
          //多选
          let options;
          // 判断是否选中
          if (
            this.value.filter(v => {
              return (
                this.year === v[0] && this.month === v[1] - 1 && i === v[2]
              );
            }).length > 0
          ) {
            options = Object.assign(
              { day: i, selected: true },
              this.getLunarInfo(this.year, this.month + 1, i),
              this.getEvents(this.year, this.month + 1, i)
            );
          } else {
            options = Object.assign(
              { day: i, selected: false },
              this.getLunarInfo(this.year, this.month + 1, i),
              this.getEvents(this.year, this.month + 1, i)
            );
            if (this.begin.length > 0) {
              let beginTime = Number(
                new Date(
                  parseInt(this.begin[0]),
                  parseInt(this.begin[1]) - 1,
                  parseInt(this.begin[2])
                )
              );
              if (beginTime > Number(new Date(this.year, this.month, i)))
                options.disabled = true;
            }
            if (this.end.length > 0) {
              let endTime = Number(
                new Date(
                  parseInt(this.end[0]),
                  parseInt(this.end[1]) - 1,
                  parseInt(this.end[2])
                )
              );
              if (endTime < Number(new Date(this.year, this.month, i)))
                options.disabled = true;
            }
            if (this.disabled.length > 0) {
              if (
                this.disabled.filter(v => {
                  return (
                    this.year === v[0] && this.month === v[1] - 1 && i === v[2]
                  );
                }).length > 0
              ) {
                options.disabled = true;
              }
            }
          }

          temp[line].push(options);
        } else {
          // 单选
          // console.log(this.lunar(this.year,this.month,i));

          let chk = new Date();
          let chkY = chk.getFullYear();
          let chkM = chk.getMonth();
          // 匹配上次选中的日期
          if (
            parseInt(seletSplit[0]) == this.year &&
            parseInt(seletSplit[1]) - 1 == this.month &&
            parseInt(seletSplit[2]) == i
          ) {
            // console.log("匹配上次选中的日期",lunarYear,lunarMonth,lunarValue,lunarInfo)
            temp[line].push(
              Object.assign(
                { day: i, selected: true },
                this.getLunarInfo(this.year, this.month + 1, i),
                this.getEvents(this.year, this.month + 1, i)
              )
            );
            this.today = [line, temp[line].length - 1];
          }
          // 没有默认值的时候显示选中今天日期
          else if (
            chkY == this.year &&
            chkM == this.month &&
            i == this.day &&
            this.value == ""
          ) {
            // console.log("今天",lunarYear,lunarMonth,lunarValue,lunarInfo)
            temp[line].push(
              Object.assign(
                { day: i, selected: true },
                this.getLunarInfo(this.year, this.month + 1, i),
                this.getEvents(this.year, this.month + 1, i)
              )
            );
            this.today = [line, temp[line].length - 1];
          } else {
            // 普通日期
            // console.log("设置可选范围",i,lunarYear,lunarMonth,lunarValue,lunarInfo)
            let options = Object.assign(
              { day: i, selected: false },
              this.getLunarInfo(this.year, this.month + 1, i),
              this.getEvents(this.year, this.month + 1, i)
            );
            if (this.begin.length > 0) {
              let beginTime = Number(
                new Date(
                  parseInt(this.begin[0]),
                  parseInt(this.begin[1]) - 1,
                  parseInt(this.begin[2])
                )
              );
              if (beginTime > Number(new Date(this.year, this.month, i)))
                options.disabled = true;
            }
            if (this.end.length > 0) {
              let endTime = Number(
                new Date(
                  parseInt(this.end[0]),
                  parseInt(this.end[1]) - 1,
                  parseInt(this.end[2])
                )
              );
              if (endTime < Number(new Date(this.year, this.month, i)))
                options.disabled = true;
            }
            if (this.disabled.length > 0) {
              if (
                this.disabled.filter(v => {
                  return (
                    this.year === v[0] && this.month === v[1] - 1 && i === v[2]
                  );
                }).length > 0
              ) {
                options.disabled = true;
              }
            }
            temp[line].push(options);
          }
        }
        // 到周六换行
        if (day == 6 && i < lastDateOfMonth) {
          line++;
        } else if (i == lastDateOfMonth) {
          // line++
          let k = 1;
          for (let d = day; d < 6; d++) {
            // console.log(this.computedNextYear()+"-"+this.computedNextMonth(true)+"-"+k)
            temp[line].push(
              Object.assign(
                { day: k, disabled: true },
                this.getLunarInfo(
                  this.computedNextYear(),
                  this.computedNextMonth(true),
                  k
                ),
                this.getEvents(
                  this.computedNextYear(),
                  this.computedNextMonth(true),
                  k
                )
              )
            );
            k++;
          }
          // 下个月除了补充的前几天开始的日期
          // nextMonthPushDays = k;
        }

      } //end for

      // console.log(this.year+"/"+this.month+"/"+this.day+":"+line)
      // 补充第六行让视觉稳定
      // if (line <= 5 && nextMonthPushDays > 0) {
      //   // console.log({nextMonthPushDays:nextMonthPushDays,line:line})
      //   for (let i = line + 1; i <= 5; i++) {
      //     temp[i] = [];
      //     let start = nextMonthPushDays + (i - line - 1) * 7;
      //     for (let d = start; d <= start + 6; d++) {
      //       temp[i].push(
      //         Object.assign(
      //           { day: d, disabled: true },
      //           this.getLunarInfo(
      //             this.computedNextYear(),
      //             this.computedNextMonth(true),
      //             d
      //           ),
      //           this.getEvents(
      //             this.computedNextYear(),
      //             this.computedNextMonth(true),
      //             d
      //           )
      //         )
      //       );
      //     }
      //   }
      // }
      let yn = this.year, mn = 0
      // if (this.month == 11) {
      //   mn = 0;
      //   yn = parseInt(this.year) + 1;
      // } else {
      //   mn = parseInt(this.month) + 1;
      // }
      mn = parseInt(this.month) + 1;
      // 塞月份
      let Ti = temp.findIndex((t) => { return t.find((tt) => { return tt.day == 1 }) })
      let Tti = temp[Ti].findIndex((tt) => { return tt.day == 1 })
      let nowNum, nowMn = mn - 1
      temp = temp.map((t, ti) => {
        t = t.map((tt, tti) => {
          if (ti == Ti && tti == Tti) {
            nowMn++
          } else if (nowNum && (tt.day < nowNum)) {
            nowMn++
          }
          nowNum = tt.day
          tt.month = nowMn
          tt.selected = false
          return tt
        })
        return t
      })
      this.days = temp
      console.log(this.days, 111)
    },
    computedPrevYear() {
      let value = this.year;
      if (this.month - 1 < 0) {
        value--;
      }
      return value;
    },
    computedPrevMonth(isString) {
      let value = this.month;
      if (this.month - 1 < 0) {
        value = 11;
      } else {
        value--;
      }
      // 用于显示目的（一般月份是从0开始的）
      if (isString) {
        return value + 1;
      }
      return value;
    },
    computedNextYear() {
      let value = this.year;
      if (this.month + 1 > 11) {
        value++;
      }
      return value;
    },
    computedNextMonth(isString) {
      let value = this.month;
      if (this.month + 1 > 11) {
        value = 0;
      } else {
        value++;
      }
      // 用于显示目的（一般月份是从0开始的）
      if (isString) {
        return value + 1;
      }
      return value;
    },
    // 获取农历信息
    getLunarInfo(y, m, d) {
      let lunarInfo = calendar.solar2lunar(y, m, d);
      let lunarValue = lunarInfo.IDayCn;
      // console.log(lunarInfo)
      let isLunarFestival = false;
      let isGregorianFestival = false;
      if (
        this.festival.lunar[lunarInfo.lMonth + "-" + lunarInfo.lDay] !=
        undefined
      ) {
        lunarValue = this.festival.lunar[
          lunarInfo.lMonth + "-" + lunarInfo.lDay
        ];
        isLunarFestival = true;
      } else if (this.festival.gregorian[m + "-" + d] != undefined) {
        lunarValue = this.festival.gregorian[m + "-" + d];
        isGregorianFestival = true;
      }
      return {
        lunar: lunarValue,
        isLunarFestival: isLunarFestival,
        isGregorianFestival: isGregorianFestival
      };
    },
    // 获取自定义事件
    getEvents(y, m, d) {
      // console.log(Object.keys(this.events).length)
      let data = {};
      let splitDate = []
      // data.eventName = '无票'
      let timeDate = `${y}-${m < 10 ? `0${m}` : m}-${d < 10 ? `0${d}` : d}`
      timeDate = new Date(timeDate)
      let beginDate = `${this.begin[0]}-${this.begin[1] < 10 ? `0${this.begin[1]}` : this.begin[1]}-${this.begin[2] < 10 ? `0${this.begin[2]}` : this.begin[2]}`
      beginDate = new Date(beginDate)
      let endDate = `${this.end[0]}-${this.end[1] < 10 ? `0${this.end[1]}` : this.end[1]}-${this.end[2] < 10 ? `0${this.end[2]}` : this.end[2]}`
      endDate = new Date(endDate)
      // if (timeDate < beginDate) {
      //   data.eventName = ''
      // }
      if (timeDate >= beginDate && timeDate <= endDate) {
        data.eventName = '有票'
      }
      if (!this.events.hasClose) return data

      if (this.events.week) {
        let week = timeDate.getDay() + 1
        week = week.toString()
        if (this.events.week.indexOf(week) > -1) data.eventName = '闭馆'
      }
      if (this.events.customCloseStart && timeDate >= this.events.customCloseStart && timeDate <= this.events.customCloseEnd) {
        data.eventName = '闭馆'
      }
      this.events.customCloseDate.split(',').forEach(item => {
        splitDate.push(new Date(item))
      })
      if (splitDate.length) {
        splitDate.forEach(item => {
          if (item && (timeDate + '') == (item + '')) {
            data.eventName = '闭馆'
            console.log('闭馆')
          }
          if (item && (timeDate + '') == (item + '')) {
            data.eventName = '闭馆'
            console.log('闭馆')
          }
        })
      }
      return data
    },
    // 上月
    prev() {
      // e.stopPropagation();
      this.$nextTick(() => {
        let c = document.querySelectorAll("td").length - 1;
        // if (
        //   document.querySelectorAll("td")[7]._prevClass === "disabled" &&
        //   document.querySelectorAll("td")[7].childElementCount === 1
        // ) {
        //   console.log("回到本月");
        // } else {
        if (this.month == 0) {
          this.month = 11;
          this.year = parseInt(this.year) - 1;
        } else {
          this.month = parseInt(this.month) - 1;
        }
        // this.render(this.year, this.month);
        // console.log("上个月");
        // this.$emit("selectMonth", this.month + 1, this.year);
        // this.$emit("prev", this.month + 1, this.year);
        this.setToday();
        this.$nextTick(() => {
          //  自动点击当前日期
          var today
          var allToday = document.querySelectorAll(".swiper-slide .today")
          let todayIndex = 0
          // if (!this.isMobile) {
          //   allToday.forEach((todayItem, index) =>{
          //     let parent = todayItem.parentElement.parentElement
          //     if (!parent) return
          //     ((parent.id == 0 || parent.id == 3) && (allToday[0].id != 0 && allToday[0].id != 3)) ? todayIndex = index : ''
          //   })
          // }
          today = allToday[todayIndex]
          if (!today) return
          // console.log(allToday, 'allToday')
          today.click();
        });
        this.$refs.mySwiper.swiper.slideTo(6, 250, false);
        // }
      });
    },
    //  下月
    next() {
      // e.stopPropagation();
      console.log('下月')
      let lastDayOfLastMonth = new Date(this.year, this.month, 0).getDate();
      this.$nextTick(() => {
        let c = document.querySelectorAll("td").length - 1;
        console.log(c);
        // if (
        //   document.querySelectorAll("td")[c]._prevClass === "disabled" &&
        //   document.querySelectorAll("td")[c].childElementCount === 1 &&
        //   document
        //     .querySelectorAll(".swiper-slide-active")[0]
        //     .children[0].querySelectorAll(".disabled")[0].childElementCount ===
        //     1
        // ) {
        //   console.log("回到本月");
        // } else {
        if (this.month == 11) {
          this.month = 0;
          this.year = parseInt(this.year) + 1;
        } else {
          this.month = parseInt(this.month) + 1;
        }
        console.log('go 下月', this.month)
        this.render(this.year, this.month);
        // this.$emit("selectMonth", this.month + 1, this.year);
        // this.$emit("next", this.month + 1, this.year);
        this.$refs.mySwiper.swiper.slideTo(0, 250, false);
        // }
      });
      // this.$refs.mySwiper.swiper.slideTo(0, 1000, false);
    },
    // 选中日期
    select(k1, k2, e) {
      let a = document.getElementsByClassName("text").length;
      let b = document.getElementsByClassName("text");
      console.log(a,);
      let i;
      for (i = 0; i < a; i++) {
        // console.log(b[i].parentNode)
        if (b[i].innerText === "闭馆") {
          // console.log(b[i].parentNode)
          b[i].parentNode.style.pointerEvents = "none";
        } else {
          // console.log("没闭馆");
        }
      }
      if (e != undefined) e.stopPropagation();
      console.log("点击");
      // 日期范围
      if (this.range) {
        if (this.rangeBegin.length == 0 || this.rangeEndTemp != 0) {
          this.rangeBegin = [this.year, this.month, this.days[k1][k2].day];
          this.rangeBeginTemp = this.rangeBegin;
          this.rangeEnd = [this.year, this.month, this.days[k1][k2].day];
          this.rangeEndTemp = 0;
        } else {
          this.rangeEnd = [this.year, this.month, this.days[k1][k2].day];
          this.rangeEndTemp = 1;
          // 判断结束日期小于开始日期则自动颠倒过来
          if (
            +new Date(this.rangeEnd[0], this.rangeEnd[1], this.rangeEnd[2]) <
            +new Date(
              this.rangeBegin[0],
              this.rangeBegin[1],
              this.rangeBegin[2]
            )
          ) {
            this.rangeBegin = this.rangeEnd;
            this.rangeEnd = this.rangeBeginTemp;
          }
          // 小于10左边打补丁
          let begin = [];
          let end = [];
          if (this.zero) {
            this.rangeBegin.forEach((v, k) => {
              if (k == 1) v = v + 1;
              begin.push(this.zeroPad(v));
            });
            this.rangeEnd.forEach((v, k) => {
              if (k == 1) v = v + 1;
              end.push(this.zeroPad(v));
            });
          } else {
            begin = this.rangeBegin;
            end = this.rangeEnd;
          }
          // console.log("选中日期",begin,end)
          this.$emit("select", begin, end);
        }
        this.render(this.year, this.month);
      } else if (this.multi) {
        // 如果已经选过则过滤掉
        let filterDay = this.multiDays.filter(v => {
          return (
            this.year === v[0] &&
            this.month === v[1] - 1 &&
            this.days[k1][k2].day === v[2]
          );
        });
        if (filterDay.length > 0) {
          this.multiDays = this.multiDays.filter(v => {
            return (
              this.year !== v[0] ||
              this.month !== v[1] - 1 ||
              this.days[k1][k2].day !== v[2]
            );
          });
        } else {
          this.multiDays.push([
            this.year,
            this.month + 1,
            this.days[k1][k2].day
          ]);
        }
        this.days[k1][k2].selected = !this.days[k1][k2].selected;
        this.$emit("select", this.multiDays);
      } else {
        // 取消上次选中
        if (this.today.length > 0) {
          this.days.forEach(v => {
            v.forEach(vv => {
              vv.selected = false;
            });
          });
        }
        // 设置当前选中天
        this.days[k1][k2].selected = true;
        this.day = this.days[k1][k2].day;
        this.today = [k1, k2];
        this.$emit("select", [
          this.year,
          this.zero ? this.zeroPad(this.month + 1) : this.days[k1][k2].month,
          this.zero
            ? this.zeroPad(this.days[k1][k2].day)
            : this.days[k1][k2].day
        ]);
      }
    },
    changeYear() {
      if (this.yearsShow) {
        this.yearsShow = false;
        return false;
      }
      this.yearsShow = true;
      this.years = [];
      for (let i = ~~this.year - 10; i < ~~this.year + 10; i++) {
        this.years.push(i);
      }
    },
    selectYear(value) {
      this.yearsShow = false;
      this.year = value;
      this.render(this.year, this.month);
      this.$emit("selectYear", value);
    },
    // 返回今天
    setToday() {
      this.year = parseInt(this.begin[0])
      this.month = parseInt(this.begin[1]) - 1;
      this.day = parseInt(this.begin[2]);
      // let now = new Date();
      // this.year = now.getFullYear();
      // this.month = now.getMonth();
      // this.day = now.getDate();
      let events = this.getEvents(this.year, this.month + 1, this.day)
      // if (events.eventName) return

      this.render(this.year, this.month);
      // 遍历当前日找到选中
      this.days.forEach(v => {
        let day = v.find(vv => {
          return vv.day == this.day && (vv.month == this.month + 1);
        });
        if (day != undefined) {
          day.selected = true;
          day.isToday = true
        }
      });
    },
    // 日期补零
    zeroPad(n) {
      return String(n < 10 ? "0" + n : n);
    },
    //屏蔽无效的日期
    shield() {
      let arr = document.querySelectorAll("td");
      // console.log(arr.length);
      arr.forEach(function (item) {
        // console.log(item.childElementCount);
        if (item.childElementCount === 1) {
          item.classList.add("disabled");
          // console.log(item._prevClass);
        } else {
          item.classList.remove("disabled");
        }
      });
    }
  },
  mounted() {
    this.init();
    this.setToday();
    this.nowMonth = (new Date).getMonth()
    // this.prev()

    this.$nextTick(() => {
      //  自动点击当前日期
      var today
      var allToday = document.querySelectorAll(".swiper-slide .today")
      let todayIndex = 0
      // if (!this.isMobile) {
      //   allToday.forEach((todayItem, index) =>{
      //     let parent = todayItem.parentElement.parentElement
      //     if (!parent) return
      //     ((parent.id == 0 || parent.id == 3) && (allToday[0].id != 0 && allToday[0].id != 3)) ? todayIndex = index : ''
      //   })
      // }
      today = allToday[todayIndex]
      if (!today) return
      console.log(today.className, 'disabled')
      if (today.className.indexOf('disabled') > -1) return
      console.log(today, 'today')
      // console.log(allToday, 'allToday')
      today.click();
    });
    // this.prev()
    
    // if(this.events.advanceBookingDays){
    //   this.prev()
    //   console.log(1111111)
    //   setTimeout(() => {
    //       this.next()
    //       console.log(222222)
    //   }, 1);
    // }
  },
  computed: {
    // swiper() {
    //   return this.$refs.mySwiper.swiper
    // }
  }
};
</script>
